import React from 'react';
import styled from 'styled-components';

const BottomStripWrapper = styled.div`
  height: 5%;
  margin: 5px 0;
  border: 1px solid green;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StatusText = styled.p`
  font-family: 'Times New Roman';
  font-size: 10px;
  color: yellow;
`;

const BottomStrip = ({ statusText }) => {
  return (
    <BottomStripWrapper>
      <StatusText>{statusText}</StatusText>
    </BottomStripWrapper>
  );
};

export default BottomStrip;

